import { generateEntityDataMachineGeneratorProps } from "@app/data/machine/actors/entityDataActorMachine/entityDataActorMachine";
import { generateOptimisticDataMachine } from "@app/data/machine/actors/optimisticDataActorMachine";

const generateEntitySavedQueryDataMachineGeneratorProps = ({ dataActorOptions }) => {
    const { type = "ENTITY_SAVED_QUERY_BUSINESS_OBJECTS" } = dataActorOptions;
    const entityDataMachineProps = generateEntityDataMachineGeneratorProps({ dataActorOptions });

    return {
        ...entityDataMachineProps,
        type,
    };
};

export const generateEntitySavedQueryDataActorMachine = ({ dataActorOptions }) => generateOptimisticDataMachine(generateEntitySavedQueryDataMachineGeneratorProps({ dataActorOptions }));
